import { getState } from '~src/state';
import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_ANNUNCIO_FUNEBRE } from '~graphql/queries/necrologi';
import { mapGiottoProjectEventToAFType } from '~src/sidebar/annunciFunebri/mapGiottoProjectEventToAFType';

export const fetchAnnuncioFunebre = async () => {
  const servizio = getState('selected.servizio');
  const templatesCategory = getState('selected.templatesCategory');
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.query({
    query: FETCH_ANNUNCIO_FUNEBRE,
    variables: {
      defuntoId: servizio.objectId,
      tipo: mapGiottoProjectEventToAFType(templatesCategory.name.toLowerCase()),
    },
    fetchPolicy: 'network-only', // Always fetch fresh data from server, bypass cache
  });

  if (
    response.data.annunci_funebris.edges &&
    response.data.annunci_funebris.edges.length > 0
  ) {
    return response.data.annunci_funebris.edges[0].node;
  }

  return null;
};
